import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {AboutLocationsPage} from "../about-locations/about-locations";
import {AboutCarbohydratePage} from "../about-carbohydrate/about-carbohydrate";
import {AboutLocationDetailsPage} from "../about-location-details/about-location-details";
import {AboutIrrigationPage} from "../about-irrigation/about-irrigation";
import {AboutIrrigationRecordsPage} from "../about-irrigation-records/about-irrigation-records";
import {AboutSprayRecordsPage} from "../about-spray-records/about-spray-records";
import {AboutThinningPage} from "../about-thinning/about-thinning";
import {AboutMeasurementDetailPage} from "../about-measurement-detail/about-measurement-detail";

@Component({
  selector: 'support',
  templateUrl: 'support.html'
})
export class SupportPage {
  constructor(public navCtrl: NavController) {
  }

    openAboutLocations() {
        this.navCtrl.push(AboutLocationsPage, {});
    }

    openAboutLocationDetails() {
        this.navCtrl.push(AboutLocationDetailsPage, {});
    }

    openAboutThinning() {
        this.navCtrl.push(AboutThinningPage, {});
    }

    openAboutMeasurementDetail() {
        this.navCtrl.push(AboutMeasurementDetailPage, {});
    }

    openAboutSprayRecords() {
        this.navCtrl.push(AboutSprayRecordsPage, {});
    }

    openAboutCarbohydrate() {
        this.navCtrl.push(AboutCarbohydratePage, {});
    }

    openAboutIrrigation() {
        this.navCtrl.push(AboutIrrigationPage, {});
    }

    openAboutIrrigationRecords() {
        this.navCtrl.push(AboutIrrigationRecordsPage, {});
    }

}




// WEBPACK FOOTER //
// ./src/pages/support/support.ts